import { HostCpu, HostPlatform } from '@ftr/contracts/regional-api'
import { AbstractClassBuilder, assertUnreachable } from '@ftr/foundation'

export function getOsSpecificHostCPU(platform: HostPlatform): HostCpu {
  switch (platform) {
    case HostPlatform.AIX:
    case HostPlatform.Android:
    case HostPlatform.FreeBSD:
    case HostPlatform.Haiku:
    case HostPlatform.OpenBSD:
    case HostPlatform.SunOS:
    case HostPlatform.Cygwin:
    case HostPlatform.NetBSD:
    case HostPlatform.Linux:
    case HostPlatform.Windows:
      return {
        model: 'Intel Gen Intel Core i7-1360P 186',
        speed: '2.2',
        cores: 16,
      }
    case HostPlatform.Darwin:
      return {
        model: 'Apple M2 Pro',
        speed: '2.4',
        cores: 12,
      }
    default:
      assertUnreachable(platform)
  }
}

export class HostCpuBuilder extends AbstractClassBuilder<HostCpu> {
  constructor(platform: HostPlatform) {
    super(HostCpu, getOsSpecificHostCPU(platform))
  }
}
